// extracted by mini-css-extract-plugin
export default {"component":"Root_component__cXtlH","routes":"Root_routes__lU+LP"};